import Request from './request'

const SimcardProfileAction = {
  getSimcardProfileAction(params, callback) {
    Request.get('simcard-profile-action/index', params).then(callback).catch(this.bad_answer)
  },
}
export default SimcardProfileAction
